import { cmsGraphql, FragmentType, getFragmentData } from '../../lib/cms/index.js'
import { Accordion, accordionBlockTypename } from '../Accordion/index.jsx'
import { CallToActionBlock, callToActionBlockTypename } from '../CallToAction/index.jsx'
import { ContentBlock, contentBlockTypename } from '../Content/index.jsx'
import { ImageBlock, imageBlockTypename } from '../ImageBlock/index.jsx'
import { OfferBlock, offerBlockTypename } from '../OfferBlock/index.jsx'
import { TableBlock, tableBlockTypename } from '../TableBlock/index.jsx'
import { VideoBlock, videoBlockTypename } from '../VideoBlock/index.jsx'

export const richTextNestedBlocksFragment = cmsGraphql(/* GraphQL */ `
  fragment richTextNestedBlocksFragment on CmsRichTextNestedBlocks {
    layout {
      __typename
      ...callToActionBlockFragment
      ...contentFragment
      ...accordionFragment
      ...videoBlockFragment
      ...offerBlockFragment
      ...tableBlockFragment
      ...imageBlockFragment
    }
  }
`)

const allBlocks = {
  [callToActionBlockTypename]: CallToActionBlock,
  [contentBlockTypename]: ContentBlock,
  [accordionBlockTypename]: Accordion,
  [videoBlockTypename]: VideoBlock,
  [offerBlockTypename]: OfferBlock,
  [tableBlockTypename]: TableBlock,
  [imageBlockTypename]: ImageBlock,
}

type BlocksProps = {
  data: FragmentType<typeof richTextNestedBlocksFragment> | null | undefined
}

type AllBlockData = { __typename: keyof typeof allBlocks }

const BlockComponent = (props: { blocks: AllBlockData[] | null | undefined }) => {
  const { blocks } = props

  if (!blocks || !Array.isArray(blocks) || blocks.length === 0) {
    return null
  }

  return (
    <>
      {blocks.map((block, index) => {
        const blockType = block.__typename

        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO
        const Block = allBlocks[blockType] as any
        if (Block) {
          return <Block key={`${blockType}-${index}`} data={block} isNested />
        }
        return null
      })}
    </>
  )
}

export const RichTextNestedBlocks = ({ data }: BlocksProps) => {
  if (!data) {
    return null
  }

  const { layout } = getFragmentData(richTextNestedBlocksFragment, data)

  const filteredLayout = layout?.filter((block) => block.__typename in allBlocks) as Omit<typeof layout, '__typename'> &
    { __typename: keyof typeof allBlocks }[]

  return <BlockComponent blocks={filteredLayout} />
}
